/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SubscriptionRouteImport } from './routes/subscription'
import { Route as SubProcessorsRouteImport } from './routes/sub-processors'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PressRouteImport } from './routes/press'
import { Route as PlatformScrollRouteImport } from './routes/platform-scroll'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as NewsRouteImport } from './routes/news'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as JoinusRouteImport } from './routes/joinus'
import { Route as DpaRouteImport } from './routes/dpa'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CompanyRouteImport } from './routes/company'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PressSlugRouteImport } from './routes/press_.$slug'
import { Route as BlogSlugRouteImport } from './routes/blog_.$slug'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionRoute = SubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => rootRouteImport,
} as any)
const SubProcessorsRoute = SubProcessorsRouteImport.update({
  id: '/sub-processors',
  path: '/sub-processors',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PressRoute = PressRouteImport.update({
  id: '/press',
  path: '/press',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformScrollRoute = PlatformScrollRouteImport.update({
  id: '/platform-scroll',
  path: '/platform-scroll',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformRoute = PlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersRoute = PartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsRoute = NewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinusRoute = JoinusRouteImport.update({
  id: '/joinus',
  path: '/joinus',
  getParentRoute: () => rootRouteImport,
} as any)
const DpaRoute = DpaRouteImport.update({
  id: '/dpa',
  path: '/dpa',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyRoute = CompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PressSlugRoute = PressSlugRouteImport.update({
  id: '/press_/$slug',
  path: '/press/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog_/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/blog': typeof BlogRoute
  '/company': typeof CompanyRoute
  '/contact': typeof ContactRoute
  '/demo': typeof DemoRoute
  '/dpa': typeof DpaRoute
  '/joinus': typeof JoinusRoute
  '/legal': typeof LegalRoute
  '/news': typeof NewsRoute
  '/partners': typeof PartnersRoute
  '/platform': typeof PlatformRoute
  '/platform-scroll': typeof PlatformScrollRoute
  '/press': typeof PressRoute
  '/privacy': typeof PrivacyRoute
  '/sub-processors': typeof SubProcessorsRoute
  '/subscription': typeof SubscriptionRoute
  '/terms': typeof TermsRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/press/$slug': typeof PressSlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/blog': typeof BlogRoute
  '/company': typeof CompanyRoute
  '/contact': typeof ContactRoute
  '/demo': typeof DemoRoute
  '/dpa': typeof DpaRoute
  '/joinus': typeof JoinusRoute
  '/legal': typeof LegalRoute
  '/news': typeof NewsRoute
  '/partners': typeof PartnersRoute
  '/platform': typeof PlatformRoute
  '/platform-scroll': typeof PlatformScrollRoute
  '/press': typeof PressRoute
  '/privacy': typeof PrivacyRoute
  '/sub-processors': typeof SubProcessorsRoute
  '/subscription': typeof SubscriptionRoute
  '/terms': typeof TermsRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/press/$slug': typeof PressSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/blog': typeof BlogRoute
  '/company': typeof CompanyRoute
  '/contact': typeof ContactRoute
  '/demo': typeof DemoRoute
  '/dpa': typeof DpaRoute
  '/joinus': typeof JoinusRoute
  '/legal': typeof LegalRoute
  '/news': typeof NewsRoute
  '/partners': typeof PartnersRoute
  '/platform': typeof PlatformRoute
  '/platform-scroll': typeof PlatformScrollRoute
  '/press': typeof PressRoute
  '/privacy': typeof PrivacyRoute
  '/sub-processors': typeof SubProcessorsRoute
  '/subscription': typeof SubscriptionRoute
  '/terms': typeof TermsRoute
  '/blog_/$slug': typeof BlogSlugRoute
  '/press_/$slug': typeof PressSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/blog'
    | '/company'
    | '/contact'
    | '/demo'
    | '/dpa'
    | '/joinus'
    | '/legal'
    | '/news'
    | '/partners'
    | '/platform'
    | '/platform-scroll'
    | '/press'
    | '/privacy'
    | '/sub-processors'
    | '/subscription'
    | '/terms'
    | '/blog/$slug'
    | '/press/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/blog'
    | '/company'
    | '/contact'
    | '/demo'
    | '/dpa'
    | '/joinus'
    | '/legal'
    | '/news'
    | '/partners'
    | '/platform'
    | '/platform-scroll'
    | '/press'
    | '/privacy'
    | '/sub-processors'
    | '/subscription'
    | '/terms'
    | '/blog/$slug'
    | '/press/$slug'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/blog'
    | '/company'
    | '/contact'
    | '/demo'
    | '/dpa'
    | '/joinus'
    | '/legal'
    | '/news'
    | '/partners'
    | '/platform'
    | '/platform-scroll'
    | '/press'
    | '/privacy'
    | '/sub-processors'
    | '/subscription'
    | '/terms'
    | '/blog_/$slug'
    | '/press_/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  BlogRoute: typeof BlogRoute
  CompanyRoute: typeof CompanyRoute
  ContactRoute: typeof ContactRoute
  DemoRoute: typeof DemoRoute
  DpaRoute: typeof DpaRoute
  JoinusRoute: typeof JoinusRoute
  LegalRoute: typeof LegalRoute
  NewsRoute: typeof NewsRoute
  PartnersRoute: typeof PartnersRoute
  PlatformRoute: typeof PlatformRoute
  PlatformScrollRoute: typeof PlatformScrollRoute
  PressRoute: typeof PressRoute
  PrivacyRoute: typeof PrivacyRoute
  SubProcessorsRoute: typeof SubProcessorsRoute
  SubscriptionRoute: typeof SubscriptionRoute
  TermsRoute: typeof TermsRoute
  BlogSlugRoute: typeof BlogSlugRoute
  PressSlugRoute: typeof PressSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription': {
      id: '/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof SubscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sub-processors': {
      id: '/sub-processors'
      path: '/sub-processors'
      fullPath: '/sub-processors'
      preLoaderRoute: typeof SubProcessorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/press': {
      id: '/press'
      path: '/press'
      fullPath: '/press'
      preLoaderRoute: typeof PressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform-scroll': {
      id: '/platform-scroll'
      path: '/platform-scroll'
      fullPath: '/platform-scroll'
      preLoaderRoute: typeof PlatformScrollRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform': {
      id: '/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof PlatformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners': {
      id: '/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof PartnersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news': {
      id: '/news'
      path: '/news'
      fullPath: '/news'
      preLoaderRoute: typeof NewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/joinus': {
      id: '/joinus'
      path: '/joinus'
      fullPath: '/joinus'
      preLoaderRoute: typeof JoinusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dpa': {
      id: '/dpa'
      path: '/dpa'
      fullPath: '/dpa'
      preLoaderRoute: typeof DpaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company': {
      id: '/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof CompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/press_/$slug': {
      id: '/press_/$slug'
      path: '/press/$slug'
      fullPath: '/press/$slug'
      preLoaderRoute: typeof PressSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog_/$slug': {
      id: '/blog_/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  BlogRoute: BlogRoute,
  CompanyRoute: CompanyRoute,
  ContactRoute: ContactRoute,
  DemoRoute: DemoRoute,
  DpaRoute: DpaRoute,
  JoinusRoute: JoinusRoute,
  LegalRoute: LegalRoute,
  NewsRoute: NewsRoute,
  PartnersRoute: PartnersRoute,
  PlatformRoute: PlatformRoute,
  PlatformScrollRoute: PlatformScrollRoute,
  PressRoute: PressRoute,
  PrivacyRoute: PrivacyRoute,
  SubProcessorsRoute: SubProcessorsRoute,
  SubscriptionRoute: SubscriptionRoute,
  TermsRoute: TermsRoute,
  BlogSlugRoute: BlogSlugRoute,
  PressSlugRoute: PressSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
